import { useContext, useMemo } from 'react';
import { CardItemsStateCtx } from '../context/card-items';
export function useItemButtons(props) {
    const { data, rowIndex } = props;
    const { operateColumn } = useContext(CardItemsStateCtx);
    return useMemo(() => {
        const buttons = operateColumn?.buttons || [];
        return buttons
            .map((item, index) => {
            try {
                if (typeof item === 'function')
                    return item(data, index);
                return item;
            }
            catch { }
            return null;
        })
            .filter((item, index) => {
            try {
                if (!item?.children)
                    return false;
                if (typeof item.visible === 'function') {
                    return item.visible(data, index);
                }
                return item.visible !== false;
            }
            catch { }
            return false;
        })
            .map((item, index) => {
            if (!item)
                return null;
            try {
                let disabled = false;
                if (typeof item.disabled === 'function') {
                    disabled = item.disabled(data, index);
                }
                else {
                    disabled = item.disabled;
                }
                const button = {
                    disabled,
                    children: item.children,
                    onClick: (e) => {
                        item.onClick?.(e, data, rowIndex);
                    },
                };
                return button;
            }
            catch { }
            return null;
        })
            .filter(Boolean);
    }, [data, operateColumn, rowIndex]);
}
